import API from "../../../../api/axiosClient";

 

const baseUrl = "MessageReaction";

const addReaction = async (
    chatMessageId: string,
    reaction: string
) => {

    await API.post(baseUrl, {

        chatMessageId,

        reaction

    });

};

const getReactions = async (
    messageId: string
) => {

    const response = await API.get(
        `${baseUrl}/message/${messageId}`
    );

    return response.data;

};

const updateReaction = async (
    reactionId: string,
    reaction: string
) => {

    await API.put(
        `${baseUrl}/${reactionId}`,
        {
            reaction
        }
    );

};


const deleteReaction = async (
    reactionId: string
) => {

    await API.delete(
        `${baseUrl}/${reactionId}`
    );

};
// eslint-disable-next-line
export default {

    addReaction,

    getReactions,

    updateReaction,

    deleteReaction

};